<template>
    <div class="import-box">
        <el-dialog
            title="导入学员"
            :visible.sync="leadFormVisible"
        >
            <div class="dislog-box excel-box"
                v-show="!visible">
                <div>
                    <div class="excel-btn" @click="doenloadTemplate">
                        <img
                            src="../../../assets/img/teacher/download.png"
                            alt=""
                        >
                        <div>下载导入模板</div>
                    </div>
                    <div class="excel-btn" @click="openUploadDialog">
                        <img
                            src="../../../assets/img/teacher/excel.png"
                            alt=""
                        >
                        <div>选择EXCEL</div>
                    </div>
                </div>
                <div
                    class="close"
                    style="text-align: center;margin-top: 20px;"
                >
                    <el-button
                        type="danger"
                        @click="leadFormVisible=false"
                    >取 消</el-button>
                </div>
            </div>
            <div class="dislog-box dialog-form"
                v-show="visible">
                <el-form
                    :model="model"
                    :rules="rules"
                    ref="dialogRef"
                    label-width="120px"
                >
                    <el-form-item
                        label="导入班级"
                        prop="teacher_class_id"
                    >
                        <el-select
                            v-model="model.teacher_class_id"
                            placeholder="请选择导入班级"
                        >
                            <el-option
                            v-for="(item, index) in classList"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        label="Excel文件"
                    >
                        <el-upload
                            class="upload-demo"
                            ref="uploadDom"
                            action="http://dclj.wyzsjy.com/teacher/student_class/import_student"
                            drag
                            :data="uploadData"
                            :limit="1"
                            :multiple="false"
                            :on-success="uploadSuccess"
                            :on-error="uploadError"
                            :on-remove="removeFile"
                            :on-change="uploadChange"
                            :before-upload="beforeUpload"
                            :auto-upload="false"
                        >
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                            <div class="el-upload__tip" slot="tip">只能上传Excel文件，且不超过100MB。<br> {{uploadTips}}</div>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <div
                    slot="footer"
                    class="dialog-footer"
                >
                    <el-button
                        type="primary"
                        @click="submitForm('dialogRef')"
                    >提 交</el-button>
                    <div style="width:70px;display: inline-block"></div>
                    <el-button
                        type="danger"
                        @click="resetForm('dialogRef')"
                    >取 消</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Lockr from "lockr";
import { getSelectData } from "@/utils/form";
import { ClassListSelect, ImportStudentTemplate } from "@/api/teacher";

export default {
    name: "import-excel",
    props: {
        classId: {
            type: [Number, String],
            default: ''
        }
    },
    components: {},
    data() {
        return {
            class_id: this.classId,
            leadFormVisible: false,
            visible: false,
            model: {
                teacher_class_id: parseInt(this.classId) || '',
                file: ''
            },
            rules: {
                teacher_class_id: [
                    { required: true, message: '请选择导入班级', trigger: 'blur' },
                ],
                file: [
                    { required: true, message: '请选择导入的Excel文件', trigger: 'blur' },
                ]
            },
            classList: [],
            uploadData: {},
            uploadType: ['xls','xlsx','xlt'],
            uploadTips: '不存在的学员和已经导入的学员会自动过滤',
            tplUrl: '',
        };
    },
    watch: {
        classId (n,o) {
            this.class_id = n
            this.model.teacher_class_id = parseInt(n) || ''
        }
    },
    methods: {
        // 打开上传组件
        open () {
            this.visible = false
            this.leadFormVisible = true
        },
        // 关闭上传组件
        cancel () {
            this.leadFormVisible = false
            this.visible = false
        },
        // 打开上传文件表单
        openUploadDialog () {
            this.visible = true
            this.getClassList()
        },
        // 获取模板地址
        async getTemplateUrl () {
            let params = {
                token: Lockr.get("teacherToken")
            };
            let studentList = [];
            let result = await ImportStudentTemplate(params);
            if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                if (result.data) {
                    this.tplUrl = result.data.tpl
                    this.uploadTips = result.data.tip
                } else {
                    this.$message({
                        message: result.msg,
                        type: "warning"
                    });
                }
            } else {
                this.$message({
                    message: result.msg,
                    type: "warning"
                });
            }
        },
        // 下载模板
        doenloadTemplate () {
            window.open(this.tplUrl)
        },
        // 重置表单
        resetForm(formName) {
            this.leadFormVisible = false
            this.$refs[formName].resetFields();
        },
        // 新增学员
        async getClassList() {
            // 获取班级
            let params = {
                token: Lockr.get("teacherToken")
            };
            let studentList = [];
            let result = await ClassListSelect(params);
            if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                this.classList = getSelectData(result.data.list, "name", "id");
            }
        },
        // 删除文件
        removeFile () {
            this.model.file = ''
        },
        // 文件上传成功
        uploadSuccess (response, file, fileList) {
            if (response.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                this.$refs.uploadDom.handleRemove(file)
                this.$parent.refreshTable()
                this.cancel()
                this.$message({
                    message: response.msg,
                    type: "success"
                });
            } else {
                this.$refs.uploadDom.handleRemove(file)
                this.$message({
                    message: response.msg,
                    type: "warning"
                });
            }
        },
        // 上传前
        beforeUpload (file) {
            if (!this.model.teacher_class_id) {
                this.$message({
                    message: '请选择班级',
                    type: "warning"
                });
                return false
            }
            let type = this.getFilesType(file.name)
            if (this.uploadType.indexOf(type) === -1) {
                this.$message({
                    message: '上传文件不支持，请选择Excel文件',
                    type: "warning"
                });
                return false
            }
            if (file.size > 100 * 1024 * 1024) {
                this.$message({
                    message: '文件过大，请选择小于100M文件',
                    type: "warning"
                });
                return false
            }
        },
        // 获取文件扩展名
        getFilesType (filename) {
            let index = filename.lastIndexOf(".")
            return filename.substr(index+1)
        },
        // 文件上传失败
        uploadError (file, fileList) {
            this.$message({
                message: '文件上传失败',
                type: "warning"
            });
        },
        // uploadChange
        uploadChange (file) {
            let type = this.getFilesType(file.name)
            if (this.uploadType.indexOf(type) === -1) {
                this.$message({
                    message: '上传文件不支持，请选择Excel文件',
                    type: "warning"
                });
                this.$refs.uploadDom.handleRemove(file)
            }
            if (file.size > 100 * 1024 * 1024) {
                this.$message({
                    message: '文件过大，请选择小于100M文件',
                    type: "warning"
                });
                this.$refs.uploadDom.handleRemove(file)
            }
            
        },
        // 重置表单
        CancelForm(formName) {
            this.close()
            this.$refs[formName].resetFields();
        },
        // 表单验证
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.requestForm()
                }
            });
        },
        requestForm () {
            let file = this.$refs.uploadDom.uploadFiles[0]
            let params = {
                token: Lockr.get("teacherToken"),
                teacher_class_id: this.model.teacher_class_id,
                title: file.name
            };
            this.uploadData = params
            setTimeout(()=>{
                this.$refs.uploadDom.submit();
            },100)
        }
    },
    created () {
        this.getTemplateUrl()
    }
};
</script>

<style lang="less" scoped>
.excel-box {
    > div:nth-of-type(1) {
        display: flex;
        justify-content: space-around;
        align-items: center;
        .excel-btn {
            width: 251px;
            height: 236px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 18px;
            cursor: pointer;
            transition: all 0.5s;
            img {
                margin-bottom: 20px;
            }
        }
        .excel-btn:hover {
            box-shadow: 0px 0px 6px -2px rgba(0, 0, 0, 0.75);
        }
    }
}
.dialog-footer{
    text-align: center;
    padding-top: 40px;
    padding-bottom: 20px;
}
.import-box .el-select{
    display: block;
}
.dialog-form{
    padding-top: 20px;
    margin: 0 10%;
    /deep/ .el-upload{
        display: block;
        .el-upload-dragger{
            width: 100%;
        }
    }
}
</style>